const PRENO_PREFIX = 'ngx_';

export const NGX_SESSION_STORAGE_KEYS = Object.freeze({
  fiscalCode: `${PRENO_PREFIX}fiscalCode`,
})
